export const CURRENT_CONFIG = {

  // license
  appId: '190615', // You need to go to the development website to apply.
  appKey: '2c49872c3cd9322376bb941a4939798', // You need to go to the development website to apply.
  appLicense: 'u4mbVH9XcrHKhsRBQMzcNj6Lq6zkGWoSdWH+XQmPHHDjOsiKA2cIzauT4UH4AaGz0O+a69XYAnGKnMku0y4xM/6QKu1DuOBW5ZF5DkSV5pWY7/yOIDOHTzp+O2ob0PCTfzahlKpz3PLSZ5mQq6BGFlZ/VTNlN3pKWyMhgTAF2e8=', // You need to go to the development website to apply.

  // http
  baseURL: 'https://dji-cloud.skydata.cz/', // This url must end with "/". Example: 'http://192.168.1.1:6789/'
  websocketURL: 'wss://dji-cloud.skydata.cz/api/v1/ws', // Example: 'ws://192.168.1.1:6789/api/v1/ws'

  // livestreaming
  // RTMP  Note: This IP is the address of the streaming server. If you want to see livestream on web page, you need to convert the RTMP stream to WebRTC stream.
  rtmpURL: 'Please enter the rtmp access address.', // Example: 'rtmp://192.168.1.1/live/'
  // GB28181 Note:If you don't know what these parameters mean, you can go to Pilot2 and select the GB28181 page in the cloud platform. Where the parameters same as these parameters.
  gbServerIp: 'Please enter the server ip.',
  gbServerPort: 'Please enter the server port.',
  gbServerId: 'Please enter the server id.',
  gbAgentId: 'Please enter the agent id',
  gbPassword: 'Please enter the agent password',
  gbAgentPort: 'Please enter the local port.',
  gbAgentChannel: 'Please enter the channel.',
  // RTSP
  rtspUserName: 'Please enter the username.',
  rtspPassword: 'Please enter the password.',
  rtspPort: '8554',
  // Agora
  agoraAPPID: 'Please enter the agora app id.',
  agoraToken: 'Please enter the agora temporary token.',
  agoraChannel: 'Please enter the agora channel.',

  // map
  // You can apply on the AMap website.
  amapKey: 'Please enter the amap key.',

}
